import { Component } from '../base/component';
import { ensureElement } from '../../utils/utils';
export class Page extends Component {
    constructor(containter, events) {
        super(containter);
        this.events = events;
        this._catalog = ensureElement('.gallery', this.container);
        this._basket = ensureElement('.header__basket', this.container);
        this._cartCounter = ensureElement('.header__basket-counter', this.container);
        this._pageWrapper = ensureElement('.page__wrapper', this.container);
        this._basket.addEventListener('click', () => {
            this.events.emit('cart:render');
        });
    }
    set catalog(items) {
        this._catalog.replaceChildren(...items);
    }
    set cartCounter(value) {
        this.setText(this._cartCounter, String(value));
    }
    set lockedWrapper(value) {
        this.toggleClass(this._pageWrapper, 'page__wrapper_locked', value);
    }
}
